import { useState } from "react";
import { Link } from "react-router-dom";

import MobileDropdown from "./MobileDropdown";

const MobileMenu = ({ handleLinkClick }) => {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);

  return (
    <div className="lg:hidden bg-white border-t border-gray-100">
      <nav className="flex flex-col px-4 py-4 space-y-2 text-sm font-medium text-gray-800">
        {/* Services */}
        <MobileDropdown
          title="Services"
          isOpen={isServicesOpen}
          setIsOpen={setIsServicesOpen}
          items={[
            { to: "/services/ai-services/", label: "AI Services" },
            { to: "/services/web-development/", label: "Web Development" },
            {
              to: "/services/mobile-app-development/",
              label: "Mobile App Development",
            },
            {
              to: "/services/software-consulting/",
              label: "Software Consulting",
            },
            {
              to: "/services/third-party-integration/",
              label: "Third Party Integration",
            },
            {
              to: "/services/custom-development/",
              label: "Custom Development",
            },
            {
              to: "/services/enterprise-application/",
              label: "Enterprise Application",
            },
            {
              to: "/services/digital-transformation/",
              label: "Digital Transformation",
            },
          ]}
          handleLinkClick={handleLinkClick}
        />

        {/* Industries */}
        <MobileDropdown
          title="Industries"
          isOpen={isIndustriesOpen}
          setIsOpen={setIsIndustriesOpen}
          items={[
            { to: "/industries/logistics/", label: "Logistics" },
            { to: "/industries/healthcare/", label: "Healthcare" },
            {
              to: "/industries/financial-services/",
              label: "Financial Services",
            },
            { to: "/industries/education/", label: "Education" },
            { to: "/industries/hospitality/", label: "Hospitality" },
            { to: "/industries/entertainment/", label: "Entertainment" },
            { to: "/industries/energy/", label: "Energy" },
            { to: "/industries/warehouse/", label: "Warehouse" },
            { to: "/industries/manufacture/", label: "Manufacture" },
            { to: "/industries/ecommerce/", label: "E-commerce" },
                { to: "/industries/construction/", label: "Construction" },
          ]}
          handleLinkClick={handleLinkClick}
        />

        {/* Company */}
        <MobileDropdown
          title="Company"
          isOpen={isCompanyOpen}
          setIsOpen={setIsCompanyOpen}
          items={[
            { to: "/company/our-advantages/", label: "Our advantages" },
            { to: "/company/our-story/", label: "Our Story" },
            { to: "/company/people-of-lentera/", label: "People Of Lentera" },
            { to: "/company/our-brand/", label: "Our Brand" },
            { to: "/company/careers/", label: "Careers" },
            { to: "/blogs", label: "Blogs", external: true },
          ]}
          handleLinkClick={handleLinkClick}
        />

        {/* Contact */}
        <Link
          to="/contact/"
          onClick={handleLinkClick}
          className="block py-2 text-sm hover:bg-gray-100"
        >
          Contact us
        </Link>

        {/* Mobile Consultation Button */}
        <a
          href="https://outlook.office365.com/book/FreeConsultation@lenteratechno.onmicrosoft.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700 text-center"
        >
          Book a Free Consultation
        </a>
      </nav>
    </div>
  );
};
export default MobileMenu;
